export const COMMON_DOUBLE_EXTENSIONS = ['tar.gz', 'tar.bz2', 'tar.xz', 'tar.Z', 'tar.lz', 'tar.lzma', 'tar.lzo', 'tar.sz', 'tar.zst', 'min.js', 'min.css']

export const detections = [
  'Pessoa',
  'Reconhecimento Facial',
  'Análise Demográfica',
  'Leitura de Placas',
  'Veículos',
  'Velocidade',
  'EPI',
  'Animais',
  'Aglomeração',
  'Objetos em Geral',
  'Capuz',
  'Carrinho de Supermercado',
  'Relatório de Contagem',
  'Mudança de Cenário',
  'Tempo de Permanência',
]

export const detectionDisableLineCrossing = [
  'Mudança de Cenário',
  'Aglomeração',
  'Reconhecimento Facial',
  'Leitura de Placas',
  'Placa',
  'Relatório de Contagem',
  'Capuz',
  'Carrinho de Supermercado',
  'Tempo de Permanência',
]

export const firstStepResourceIdSet = ['Pessoa', 'Reconhecimento Facial', 'Leitura de Placas', 'Mudança de Cenário', 'Aglomeração']

export const skipThirdStep = ['Mudança de Cenário']

export const skipFourthStep = ['Relatório de Contagem', 'Análise Demográfica']

export const EnumLprIntegrations = [
  {id: 'Spia', label: 'Polícia Rodoviária Federal - Spia', lprIntegrationId: 4, dispatchToSpia: true, inputLabel: ''},
  {id: 'Harpia', label: 'Polícia Rodoviária do Paraná - Harpia', lprIntegrationId: 5, dispatchToHarpia: true, inputLabel: 'Identificador da câmera'},
  {id: 'Sivana', label: 'Receita Federal - Sivana', lprIntegrationId: 6, dispatchToSivana: true, inputLabel: 'Código do ponto'},
  {id: 'Aspide', label: 'Plataforma Áspide', lprIntegrationId: 7, dispatchToAspide: true, inputLabel: 'Código do equipamento'},
  {id: 'MuralhaPaulista', label: 'Plataforma Muralha Paulista', lprIntegrationId: 8, dispatchToMuralhaPaulista: true, inputLabel: 'Código da câmera'},
]

export const detectionsNotAllowedOnVmsCameras = [
  'Reconhecimento Facial',
  'Leitura de Placas',
  'Mudança de Cenário',
  'Relatório de Contagem',
  'Velocidade',
  'Análise Demográfica',
  'Tempo de Permanência',
]

export enum DispatchAllAndBlockUnknownIds {
  DESCONHECIDAS = -1,
  TODAS = -2,
}

export const detectionsToDrawArea = ['Velocidade']

export const dontShowDropdownSelectForDetections = [
  'facial',
  'placa',
  'reconhecimento facial',
  'análise demográfica',
  'leitura de placas',
  'tempo de permanência',
  'pessoa',
  'velocidade',
  'aglomeração',
  'capuz',
  'carrinho de supermercado',
]
export const detectionsWithSimpleChoicesToRecognition = ['relatório de contagem']

export const epiOptions = [
  {value: 'helmet', label: 'Capacete'},
  {value: 'safety-clothes', label: 'Colete'},
  {value: 'jacket', label: 'Jaqueta'},
]

export const vehicleOptions = [
  {value: 'airplane', label: 'Avião'},
  {value: 'boat', label: 'Barco'},
  {value: 'bicycle', label: 'Bicicleta'},
  {value: 'truck', label: 'Caminhão'},
  {value: 'car', label: 'Carro'},
  {value: 'bus', label: 'Ônibus'},
  {value: 'motorcycle', label: 'Moto'},
  {value: 'train', label: 'Trem'},
]

export const objectsOptions = [
  {
    value: 'bench',
    label: 'Banco de Sentar',
  },
  {
    value: 'handbag',
    label: 'Bolsa',
  },
  {
    value: 'chair',
    label: 'Cadeira',
  },
  {
    value: 'cell phone',
    label: 'Celular',
  },
  {
    value: 'spoon',
    label: 'Colher',
  },
  {
    value: 'laptop',
    label: 'Computador Portátil',
  },
  {
    value: 'cup',
    label: 'Copo',
  },
  {
    value: 'knife',
    label: 'Faca',
  },
  {
    value: 'fork',
    label: 'Garfo',
  },
  {
    value: 'bottle',
    label: 'Garrafa',
  },
  {
    value: 'umbrella',
    label: 'Guarda-Chuva',
  },
  {
    value: 'book',
    label: 'Livro',
  },
  {
    value: 'suitcase',
    label: 'Mala de Viagem',
  },
  {
    value: 'backpack',
    label: 'Mochila',
  },
  {
    value: 'mouse',
    label: 'Mouse',
  },
  {
    value: 'tennis racket',
    label: 'Raquete de Tênis',
  },
  {
    value: 'clock',
    label: 'Relógio',
  },
  {
    value: 'baseball bat',
    label: 'Taco de Beisebol',
  },
  {
    value: 'keyboard',
    label: 'Teclado',
  },
  {
    value: 'tv',
    label: 'Televisão',
  },
  {
    value: 'scissors',
    label: 'Tesoura',
  },
  {
    value: 'vase',
    label: 'Vaso',
  },
  {
    value: 'potted plant',
    label: 'Vaso de Planta',
  },
]

export const countingObjectsOptions = [
  {id: '1', label: 'Pessoa'},
  {id: '38', label: 'Vaca'},
  {id: '37', label: 'Ovelha'},
  {id: '36', label: 'Cavalo'},
  {id: '35', label: 'Cão'},
  {id: '34', label: 'Gato'},
]

export const animalsOptions = [
  {value: 'cow', label: 'Vaca'},
  {value: 'shepp', label: 'Ovelha'},
  {value: 'horse', label: 'Cavalo'},
  {value: 'dog', label: 'Cão'},
  {value: 'cat', label: 'Gato'},
]
